var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 176,
    height: 143,
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    lang: "en",
    id: titleId
  }, "shot") : title ? /*#__PURE__*/React.createElement("title", {
    lang: "en",
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    y1: "49.931%",
    y2: "49.931%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E7E7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: ".544%",
    x2: "100.708%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E7E7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "0%",
    x2: "99.438%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E7E7E7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.56,
    height: 52.74,
    x: 87.1,
    y: 28.06,
    fill: "#C9C9C9",
    rx: 2.23
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26.56,
    height: 52.74,
    x: 91.49,
    y: 28.06,
    fill: "#7D7D7D",
    rx: 2.23
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26.56,
    height: 52.74,
    x: 91.49,
    y: 28.06,
    fill: "#404040",
    rx: 2.23
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3B0B0",
    d: "M64.58 47H39.66c-3.674.01-6.649 2.974-6.66 6.633v78.744c.016 3.655 2.99 6.612 6.66 6.623h24.92V47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M-1 76.49a1.52 1.52 0 0 1-.926 1.392c-.56.244-1.195.097-1.633-.318a1.465 1.465 0 0 1-.317-1.636c.243-.562.78-.928 1.39-.928.39 0 .78.147 1.047.44.293.293.439.659.439 1.05zM81 7.986c0 .814-.488 1.53-1.235 1.856-.748.326-1.593.13-2.178-.423a1.954 1.954 0 0 1-.422-2.182A2.019 2.019 0 0 1 79.017 6c.52 0 1.04.195 1.398.586.39.39.585.88.585 1.4z",
    opacity: 0.324
  }), /*#__PURE__*/React.createElement("rect", {
    width: 108.32,
    height: 92,
    x: 53,
    y: 47,
    fill: "#C9C9C9",
    rx: 5.86
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C2C2C",
    d: "M111.14 114.1h20.64a25.29 25.29 0 0 0-.12-44.6h-19.88a12.91 12.91 0 0 0-8.37 3 25.25 25.25 0 0 0 .82 39.27 11.22 11.22 0 0 0 6.91 2.33z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.76,
    cy: 91.8,
    r: 22.3,
    fill: "#000",
    opacity: 0.745
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M129.52 86.23a4.63 4.63 0 1 0 4.62-4.63 4.62 4.62 0 0 0-4.62 4.63zm-3.41 6.25a1.55 1.55 0 1 0 3.1 0 1.55 1.55 0 0 0-3.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M78.18 64.73H66.44a3.65 3.65 0 0 1-3.64-3.64 3.64 3.64 0 0 1 3.64-3.63h11.74a3.64 3.64 0 0 1 3.63 3.63 3.64 3.64 0 0 1-3.63 3.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M134.04 42.35L165.6 38l-31.23-6L130.02.44l-5.99 31.23-31.56 4.35 31.22 5.99 4.35 31.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636363",
    d: "M45.73 113.658l-2.355-1.466 7.315-3.225-2.992-6.882a9.946 9.946 0 0 0-8.458-5.3h-15.1a9.97 9.97 0 0 0-8.458 5.3l-2.992 6.882 7.303 3.248-2.332 1.443-1.308 11.127 15.313-.235 15.313.235-1.248-11.127z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBB",
    d: "M50.706 108.785l1.57 5.12c1.134 3.774-.109 7.853-3.165 10.385l-7.127 5.495-2.294-6.149 3.95-3.63a3.897 3.897 0 0 0 .969-4.528l-1.509-3.34 7.606-3.353zM20.69 141.048l-5.875.737-1.125-1.158.568-2.084 5.648-.758z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.69 141.736l-7.54.948s-7.412.984-6.358-3.2c1.054-4.186 7.69-2.254 7.69-2.254l6.196.771a3.289 3.289 0 0 0-.08 3.557l.092.178z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M.78 139.427c.388-1.511 1.555-2.571 2.91-2.642v6c-1.689-.222-3.42-1-2.91-3.358z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBB",
    d: "M41.12 45.11v2.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.69 138.785h1v2h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBB",
    d: "M39.8 45.11v2.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.69 138.785h1v2h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBB",
    d: "M12.679 108.785l-1.571 5.092c-1.142 3.781.103 7.871 3.167 10.403l7.132 5.505 2.283-6.16-3.94-3.637a3.931 3.931 0 0 1-.983-4.534l1.522-3.347-7.61-3.322zm30.011 32.663l6.72.337 1.28-1.158-.64-2.084-6.375-.758z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M49.69 141.736l7.538.948s7.422.984 6.357-3.2c-1.065-4.186-7.689-2.254-7.689-2.254l-6.206.771a3.265 3.265 0 0 1 .092 3.557l-.092.178z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M63.541 139.427c-.512-1.515-2.06-2.576-3.851-2.642v6c2.255-.222 4.622-1 3.851-3.358z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBB",
    d: "M76.35 45.11v2.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M52.69 138.785h1v2h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBB",
    d: "M77.67 45.11v2.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M53.69 138.785h1v2h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1E1E1",
    d: "M19.69 115.785h26v16h-26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACACAC",
    d: "M19.69 130.785h26v1h-26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M31.69 122.785a1 1 0 1 0 1-1 1.01 1.01 0 0 0-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M63.337 127.011c5.05 9.15-45.788 14.774-45.788 14.774l-.86-4.077s40.431-21.993 46.648-10.697z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M.949 126.927c-4.3 9.337 46.363 14.858 46.363 14.858l.378-4.459S6.04 115.932.949 126.926z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACACAC",
    d: "M34.69 96.454c-.49-1.426-1.373-5.67-1.373-5.67l-5.627 1.07v4.635a7.655 7.655 0 0 0 3.445 1.296 5.666 5.666 0 0 0 3.555-1.331z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBB",
    d: "M34.385 83.882l-1.051-6.097-10.644 1.253.652 7.015s.822 8.674 6.5 7.648c6.138-1.122 4.809-9.903 4.543-9.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M36.69 83.09c-.12-.87.026-1.758.42-2.533 1.735-2.987-.886-3.86-1.804-4.11-.92-.251-1.328-1.936-2.677-2.473-2.076-.8-3.244 1.195-4.367 1.302-1.123.108-2.269-1.111-3.528.191-1.259 1.303-.749 2.521-1.077 3.226-.33.705-1.69-.478-2.677 1.732a2.327 2.327 0 0 0-.159 1.896c.22.625.694 1.114 1.293 1.33a4.244 4.244 0 0 0 3.834.096 17.529 17.529 0 0 0 4.015-2.569c.386-.334 3.403-.561 3.698-.096.862 1.542.93 6.703.93 6.703l.896-1.314c.993-.783 1.463-2.104 1.202-3.381z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBB",
    d: "M33.823 84.538c-.279.54-.104 1.087.372 1.217.476.13 1.08-.182 1.359-.712.279-.53.116-1.087-.372-1.226-.488-.14-1.08.191-1.359.721z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#838383",
    d: "M23.551 17.372v-1.244c0-.622-.501-1.128-1.118-1.128-.618 0-1.119.506-1.119 1.128v1.244H20.08A1.142 1.142 0 0 0 19 18.5c0 .622.463 1.128 1.08 1.128h1.234v1.244c0 .622.501 1.128 1.119 1.128.617 0 1.118-.506 1.118-1.128v-1.244h1.234c.424.039.81-.195 1.041-.545.232-.35.232-.816 0-1.166-.231-.35-.617-.584-1.04-.545H23.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5F5F5F",
    d: "M74.333 36.685v-.898a.83.83 0 0 0-.819-.787c-.424 0-.82.337-.82.787v.898h-.903A.83.83 0 0 0 71 37.5c0 .45.339.815.791.815h.876v.898a.83.83 0 0 0 .819.787c.424 0 .82-.337.82-.787v-.898h.903A.83.83 0 0 0 76 37.5c0-.45-.339-.815-.791-.815h-.876z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShot);
export default __webpack_public_path__ + "static/media/shot.cb0ca5d04a2564a2ad8e624b8549d615.svg";
export { ForwardRef as ReactComponent };